import script from "./BotLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BotLayout.vue?vue&type=script&setup=true&lang=js"

import "./BotLayout.vue?vue&type=style&index=0&id=f705e176&lang=scss"

const __exports__ = script;

export default __exports__